import faciey from '../assets/imgs/project_thumbnails/faciey.png';
import finna from '../assets/imgs/project_thumbnails/finna.png';
import axgen from '../assets/imgs/project_thumbnails/axgen-shot.png';
import boredBuddha from '../assets/imgs/project_thumbnails/bored-buddha-shot.png';
import ena from '../assets/imgs/project_thumbnails/ena.png';
import swiftlynx from '../assets/imgs/project_thumbnails/swiftlynx.png';
import chatxbt from '../assets/imgs/project_thumbnails/chatxbt.gif';

// entry shape: { name, description, thumbnail, tools, github, preview,
//   isFeatured?: boolean  — sorts first, featured styling + "Featured" badge
//   badge?: string        — extra label on the card, e.g. 'Founder' }
export const data = [
	{
		name: 'Faciey',
		description:
			'A face-recognition profile discovery app I founded — point, scan, discover. Shazam for faces meets Linktree for identity: creators and public figures get discovered by their face, with privacy-first, opt-in profiles.',
		thumbnail: faciey,
		tools: ['fa-react', 'fa-node', 'fa-python', 'fa-docker'],
		github: '#',
		preview: 'https://www.faciey.com/',
		isFeatured: true,
		badge: 'Founder',
	},
	{
		name: 'Finna',
		description:
			'A stablecoin fintech platform — instant stablecoin-to-fiat swaps, crypto-backed loans, global transfers, and payment cards. Borderless money, in your hands.',
		thumbnail: finna,
		tools: ['fa-react', 'fa-node', 'fa-ethereum', 'fa-docker'],
		github: '#',
		preview: 'https://finnahq.com/',
	},
	{
		name: 'Earnathon website',
		description: 'a website to learn about blockchain and earn tokens.',
		thumbnail: ena,
		tools: ['fa-html5', 'fa-css3-alt', 'fa-js-square', 'fa-react', 'fa-node'],
		github: 'https://github.com/Earnathon/earnathon-learn-and-earn-v2',
		preview: 'https://earnathon.com/',
	},
	{
		name: 'ChatXbt',
		description:
			'an AI-powered crypto companion offering real-time market updates, portfolio management, and financial suggestions.',
		thumbnail: chatxbt,
		tools: ['fa-html5', 'fa-css3-alt', 'fa-js-square', 'fa-react', 'fa-node'],
		github: 'https://github.com/chatxbt/chatXBT-client',
		preview: 'https://www.chatxbt.com/',
	},
	{
		name: 'bored buddha NFT website',
		description: 'a website built for bored buddha NFT.',
		thumbnail: boredBuddha,
		tools: ['fa-html5', 'fa-css3-alt', 'fa-js-square', 'fa-react'],
		github: 'https://github.com/Whizzie99/bored-buddha',
		preview: 'https://bored-buddha-dev.netlify.app/',
	},
	{
		name: 'axgen NFT website',
		description: 'Website for the AxGen NFT collection',
		thumbnail: axgen,
		tools: ['fa-html5', 'fa-css3-alt', 'fa-js-square', 'fa-react'],
		github: 'https://github.com/Whizzie99/axgen-client',
		preview: 'https://axgen-test.netlify.app/',
	},
	{
		name: 'Swiftlynx site',
		description: 'website for IT services, Partnership & Funds offer to scale up businesses',
		thumbnail: swiftlynx,
		tools: ['fa-html5', 'fa-css3-alt', 'fa-js-square', 'fa-php'],
		github: '#',
		preview: 'https://www.swiftlynxtechnologies.com/',
	},
];
